import 'shared/global';
//import "shared/vilynx.js";
import 'components/subnav';
import 'video/utils/globals';

import gridAndCarousels from 'video/gridAndCarousels';

export default function VideoPageBelowTheFold(moreEpisodesEndpoint, carouselsEndpoint) {
    try {
        gridAndCarousels(moreEpisodesEndpoint, carouselsEndpoint);
    } catch (e) {
        console.error('Video Below the fold failed to load');
    }
}
